import { useEffect } from 'react'

const allowedOrigins = process.env.REACT_APP_ALLOWED_ORIGIN_CLIENT_URLS

export const ALLOWED_CLIENT_URLS: Array<string> = allowedOrigins?.split(',') ?? []

export enum EventType {
  CLIENT_RESIZE_EVENT = 'CLIENT_RESIZE_EVENT',
  SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN',
  INJECTED_TOKEN_PROVIDER_INITIALIZED = 'INJECTED_TOKEN_PROVIDER_INITIALIZED',
  SYNCHRONIZE_DATA = 'SYNCHRONIZE_DATA',
}

export type WindowMessage<T = Record<string, string>> = { type: EventType; payload: T }

function useWindowMessage(handleMessage: (data: WindowMessage, origin: string) => void) {
  useEffect(() => {
    const handleMessageEvent = (event: MessageEvent<WindowMessage>) => {
      if (!ALLOWED_CLIENT_URLS.some((client) => event.origin.includes(client))) {
        return
      }
      handleMessage(event.data, event.origin)
    }

    window.addEventListener('message', handleMessageEvent)

    return () => window.removeEventListener('message', handleMessageEvent)
  }, [])
}

export { useWindowMessage }
